import axios from 'axios'
import {API_URL} from '../constants';

const ORDERS_API_URL = `${API_URL}/orders`;

class OrderDataService {

    retrieveAllOrders() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${ORDERS_API_URL}/findAll`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveOrdersBy(fromDate, toDate, status, country, customer, orderNo, woStatus) {
        if (status === undefined || status === null){
            status = "all";
        }

        if (country === undefined || country === null){
            country = "all";
        }

        if (customer === undefined || customer === null){
            customer = "";
        }

        if (orderNo === undefined || orderNo === null){
            orderNo = "";
        }

        var info = {
            fromDate: fromDate,
            toDate: toDate,
            status: status,
            country: country,
            customer: customer,
            orderNo: orderNo,
            woStatus: woStatus
        };
        const token = sessionStorage.getItem('token');
        return axios.post(`${ORDERS_API_URL}/findBy`,info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updateStatus(status, note, ids) {
        var info = {
            status: status,
            note: note,
            ids: ids
        };
        const token = sessionStorage.getItem('token');
        return axios.post(`${ORDERS_API_URL}/updateStatus`,info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    countByWorkOrderStatus(status) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${ORDERS_API_URL}/countByWorkOrderStatus/${status}`, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            return error;
        });
    }    
}

export default new OrderDataService()